import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  error?: string;
  required?: boolean;
}

export default function PasswordInput({
  id,
  value,
  onChange,
  label,
  error,
  required = false
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-navy-200 mb-1">
        {label}
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          required={required}
          className={`
            w-full px-4 py-3 rounded-lg bg-navy-900/50
            text-navy-100 placeholder-navy-500
            transition-all duration-200
            ${error
              ? 'border border-error-400 focus:border-error-500 focus:ring-2 focus:ring-error-500/30'
              : 'border border-navy-600 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30'
            }
          `}
          placeholder="••••••••"
          minLength={8}
          pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$"
          title="A senha deve conter pelo menos 8 caracteres, incluindo letras e números"
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-navy-400 hover:text-accent-400 transition-colors duration-200"
        >
          {showPassword ? (
            <EyeOff className="h-5 w-5" />
          ) : (
            <Eye className="h-5 w-5" />
          )}
        </button>
      </div>
      {error && (
        <p className="mt-1 text-sm text-error-400">{error}</p>
      )}
      <p className="mt-1 text-xs text-navy-400">
        A senha deve conter pelo menos 8 caracteres, incluindo letras e números
      </p>
    </div>
  );
}
